// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==================== SettingsGridLayout.css ====================
   All classes prefixed st_ or st- to avoid global collisions.
   No sidebar. Horizontal tab bar. Centred 80% container.
   ============================================================== */

/* ── Page wrapper ──────────────────────────────────────────────────────── */
.st-page-wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: rgba(10, 10, 10, 0.97);
  color: white;
  padding-top: 70px;           /* ✅ clears fixed Navbar height          */
  box-sizing: border-box;
}

/* ── Tab bar outer strip (full width, dark bg) ─────────────────────────── */
.st-tab-bar-wrapper {
  width: 100%;
  background: rgba(18, 18, 18, 0.98);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  position: sticky;
  top: 56px;                   /* ✅ sits just below the fixed Navbar     */
  z-index: 100;
  box-sizing: border-box;
}

/* ── Tab bar inner (centred, 80% wide, flex row) ───────────────────────── */
.st-tab-bar {
  width: 80%;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  padding: 0 0 0 0;
  overflow-x: auto;
  scrollbar-width: none;       /* hide scrollbar on Firefox               */
  box-sizing: border-box;
}

.st-tab-bar::-webkit-scrollbar {
  display: none;               /* hide scrollbar on Chrome/Safari         */
}

/* ── Individual tab button ─────────────────────────────────────────────── */
.st-tab-btn {
  flex-shrink: 0;
  background: transparent;
  border: none;
  border-bottom: 3px solid transparent;
  color: rgba(255, 255, 255, 0.50);
  font-family: 'Trebuchet MS', 'Lucida Sans Unicode', Arial, sans-serif;
  font-size: 13.5px;
  font-weight: 500;
  padding: 14px 16px 11px 16px;
  cursor: pointer;
  transition: color 0.18s ease, border-bottom-color 0.18s ease;
  white-space: nowrap;
  letter-spacing: 0.01em;
}

.st-tab-btn:hover {
  color: rgba(255, 255, 255, 0.85);
  background: rgba(255, 255, 255, 0.04);
}

/* Active tab */
.st-tab-btn--active {
  color: #ffffff !important;
  border-bottom-color: white;
  font-weight: 700;
}

/* Danger tab (Delete Account) */
.st-tab-btn--danger {
  color: rgba(244, 67, 54, 0.65);
}

.st-tab-btn--danger:hover,
.st-tab-btn--danger.st-tab-btn--active {
  color: #f44336 !important;
  border-bottom-color: #f44336;
}

/* Logout — pushed to far right */
.st-tab-btn--logout {
  margin-left: auto;
  color: rgba(255, 152, 0, 0.70);
}

.st-tab-btn--logout:hover {
  color: #ff9800 !important;
}

/* ── Settings container (centred, 80%) ─────────────────────────────────── */
.st-settings-container {
  width: 80%;
  margin: 40px auto 80px auto;  /* ✅ centred horizontally, breathing room  */
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

/* ── Settings content area ─────────────────────────────────────────────── */
.st-settings-content {
  width: 100%;
  box-sizing: border-box;
}

/* ── Panel base ────────────────────────────────────────────────────────── */
.st-panel {
  background: rgba(24, 24, 28, 0.85);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 16px;
  padding: 36px 40px 44px 40px;
  width: 100%;
  box-sizing: border-box;
  animation: st-panelFadeIn 0.22s ease;
}

@keyframes st-panelFadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to   { opacity: 1; transform: translateY(0);    }
}

.st-panel-title {
  font-family: 'Trebuchet MS', Arial, sans-serif;
  font-size: 1.6rem;
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 6px 0;
  padding: 0;
}

.st-panel-subtitle {
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.45);
  margin: 0 0 32px 0;
  padding: 0;
  line-height: 1.6;
  border-bottom: 1px solid rgba(255,255,255,0.07);
  padding-bottom: 20px;
}

.st-panel-body {
  display: flex;
  flex-direction: column;
  gap: 0;
}

/* ── Form rows ─────────────────────────────────────────────────────────── */
.st-form-row {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 20px;
}

.st-form-label {
  font-size: 13px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.55);
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

.st-form-input {
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 8px;
  color: #ffffff;
  font-size: 14px;
  padding: 11px 14px;
  outline: none;
  transition: border-color 0.18s ease, background 0.18s ease;
  box-sizing: border-box;
  width: 100%;
  max-width: 520px;
}

.st-form-input:focus {
  border-color: #4caf50;
  background: rgba(76, 175, 80, 0.06);
}

.st-form-input[readonly] {
  opacity: 0.45;
  cursor: default;
}

.st-form-textarea {
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 8px;
  color: #ffffff;
  font-size: 14px;
  padding: 11px 14px;
  outline: none;
  resize: vertical;
  transition: border-color 0.18s ease;
  box-sizing: border-box;
  width: 100%;
  max-width: 520px;
  font-family: Arial, sans-serif;
}

.st-form-textarea:focus {
  border-color: #4caf50;
}

.st-form-select {
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 8px;
  color: #ffffff;
  font-size: 14px;
  padding: 11px 14px;
  outline: none;
  cursor: pointer;
  max-width: 520px;
  width: 100%;
  box-sizing: border-box;
}

.st-form-select option {
  background: #1a1a1a;
}

/* ── Buttons ───────────────────────────────────────────────────────────── */
.st-save-btn {
  align-self: flex-start;
  background: rgba(36,36,45,0.2);
  color: #fff;
  border: "1px solid white";
  border-radius: 9px;
  padding: 12px 32px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  margin-top: 8px;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.st-save-btn:hover {
  transform: translateY(-1px);
}

.st-danger-btn {
  align-self: flex-start;
  background: rgba(244, 67, 54, 0.15);
  color: #f44336;
  border: 2px solid #f44336;
  border-radius: 9px;
  padding: 12px 32px;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.15s ease;
}

.st-danger-btn:hover {
  background: rgba(244, 67, 54, 0.28);
}

/* ── Toggle switch ─────────────────────────────────────────────────────── */
.st-toggle-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 0;
  border-bottom: 1px solid rgba(255,255,255,0.06);
  max-width: 520px;
}

.st-toggle-label {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.80);
}

.st-switch {
  position: relative;
  display: inline-block;
  width: 44px;
  height: 24px;
  flex-shrink: 0;
}

.st-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.st-slider {
  position: absolute;
  inset: 0;
  background: rgba(255,255,255,0.15);
  border-radius: 24px;
  cursor: pointer;
  transition: background 0.25s ease;
}

.st-slider::before {
  content: "";
  position: absolute;
  width: 18px;
  height: 18px;
  left: 3px;
  top: 3px;
  background: #fff;
  border-radius: 50%;
  transition: transform 0.25s ease;
}

.st-switch input:checked + .st-slider {
  background: #4caf50;
}

.st-switch input:checked + .st-slider::before {
  transform: translateX(20px);
}

/* ── Info cards (Subscription) ─────────────────────────────────────────── */
.st-info-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  background: rgba(255,255,255,0.04);
  border: 1px solid rgba(255,255,255,0.08);
  border-radius: 10px;
  margin-bottom: 14px;
  max-width: 520px;
}

.st-info-card-label {
  font-size: 13px;
  color: rgba(255,255,255,0.50);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.st-info-card-value {
  font-size: 15px;
  font-weight: 700;
  color: #ffffff;
}

/* ── Reward cards ──────────────────────────────────────────────────────── */
.st-rewards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 16px;
  max-width: 560px;
}

.st-reward-card {
  background: rgba(255,255,255,0.05);
  border: 1px solid rgba(255,255,255,0.09);
  border-radius: 12px;
  padding: 22px 16px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  transition: background 0.2s ease;
}

.st-reward-card:hover {
  background: rgba(255,255,255,0.08);
}

.st-reward-icon  { font-size: 2rem; }
.st-reward-value { font-size: 1.4rem; font-weight: 700; color: #fff; }
.st-reward-label { font-size: 12px; color: rgba(255,255,255,0.45); text-transform: uppercase; letter-spacing: 0.05em; }

/* ── Danger box (Delete Account) ───────────────────────────────────────── */
.st-danger-box {
  background: rgba(244, 67, 54, 0.06);
  border: 1px solid rgba(244, 67, 54, 0.22);
  border-radius: 12px;
  padding: 28px;
  max-width: 560px;
}

.st-danger-input {
  border-color: rgba(244, 67, 54, 0.4) !important;
}

.st-danger-input:focus {
  border-color: #f44336 !important;
  background: rgba(244, 67, 54, 0.06) !important;
}

/* ── Responsive ────────────────────────────────────────────────────────── */
@media (max-width: 1024px) {
  .st-settings-container { width: 90%; }
  .st-tab-bar             { width: 90%; }
}

@media (max-width: 768px) {
  .st-settings-container { width: 96%; margin: 24px auto 60px auto; }
  .st-tab-bar             { width: 100%; padding: 0 12px; }
  .st-panel               { padding: 24px 20px 32px 20px; }
  .st-tab-btn             { font-size: 12.5px; padding: 12px 12px 9px 12px; }
}

@media (max-width: 480px) {
  .st-settings-container { width: 100%; margin: 16px auto 48px auto; }
  .st-panel               { padding: 18px 14px 28px 14px; border-radius: 10px; }
  .st-rewards-grid        { grid-template-columns: repeat(2, 1fr); }
}

/* ==================== SUBSCRIPTION PANEL STYLES ====================
   Prefix: sub- to avoid collisions with st- classes
   ============================================================ */

   .sub-root {
    display: flex;
    flex-direction: column;
    gap: 0;
  }
  
  /* ── Sections ──────────────────────────────────────────────────────────── */
  .sub-section {
    border-radius: 12px;
    padding: 24px;
    margin-bottom: 24px;
  }
  
  .sub-section--payment {
    border-color: rgba(76, 175, 80, 0.20);
    background: rgba(76, 175, 80, 0.03);
  }
  
  .sub-section--features {
    border-color: rgba(33, 150, 243, 0.20);
    background: rgba(33, 150, 243, 0.03);
  }
  
  .sub-section-title {
    font-size: 15px;
    font-weight: 700;
    color: #fff;
    margin: 0 0 18px 0;
    padding-bottom: 12px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.07);
  }
  
  /* ── Empty state ───────────────────────────────────────────────────────── */
  .sub-empty-state {
    color: #ffc107;
    font-size: 14px;
    padding: 20px 0;
  }
  
  .sub-link {
    color: #64b5f6;
    text-decoration: none;
    font-weight: 600;
  }
  
  .sub-link:hover {
    text-decoration: underline;
  }
  
  /* ── Badges ────────────────────────────────────────────────────────────── */
  .sub-badge {
    display: inline-block;
    padding: 8px 16px;
    border-radius: 6px;
    font-size: 13px;
    font-weight: 700;
    margin-bottom: 16px;
    color: white;
  }
  
  .sub-badge--all {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  }
  
  .sub-badge--custom {
    background: "rgba(36,36,45,0.2)";
    border: "1px solid gray";
  }
  
  /* ── Pricing display ───────────────────────────────────────────────────── */
  .sub-pricing {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 18px;
  }
  
  .sub-price {
    font-size: 48px;
    font-weight: 700;
    color: #ffc107;
  }
  
  .sub-period {
    font-size: 16px;
    color: rgba(255, 255, 255, 0.6);
  }
  
  /* ── Savings badge ─────────────────────────────────────────────────────── */
  .sub-savings {
    display: inline-block;
    background: #28a745;
    color: white;
    padding: 8px 12px;
    border-radius: 6px;
    font-size: 13px;
    font-weight: 600;
    margin-bottom: 18px;
  }
  
  /* ── Features box ──────────────────────────────────────────────────────── */
  .sub-features-box {
    background: rgba(0, 0, 0, 0.25);
    border-radius: 8px;
    padding: 16px;
    margin-top: 16px;
  }
  
  .sub-features-title {
    color: white;
    font-size: 14px;
    font-weight: 700;
    margin: 0 0 12px 0;
    padding: 0;
  }
  
  .sub-features-list {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  
  .sub-feature-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
    color: rgba(255, 255, 255, 0.8);
    font-size: 13px;
  }
  
  .sub-feature-item:last-child {
    border-bottom: none;
  }
  
  .sub-feature-check {
    color: #ffc107;
    margin-right: 8px;
    font-weight: 700;
  }
  
  .sub-feature-name {
    flex: 1 1;
  }
  
  .sub-feature-price {
    color: #fff;
    font-size: 12px;
  }
  
  .sub-feature-price--free {
    color: #20c997;
    font-weight: 600;
  }
  
  /* ── Checkbox row ──────────────────────────────────────────────────────── */
  .sub-checkbox-row {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-top: 20px;
    padding: 12px 0;
    cursor: pointer;
  }
  
  .sub-checkbox {
    width: 18px;
    height: 18px;
    cursor: pointer;
    accent-color: #4caf50;
  }
  
  .sub-checkbox-label {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.8);
  }
  
  /* ── Payment tabs ──────────────────────────────────────────────────────── */
  .sub-payment-tabs {
    display: flex;
    gap: 12px;
    margin-bottom: 24px;
  }
  
  .sub-payment-tab {
    flex: 1 1;
    padding: 12px 16px;
    background: transparent;
    border: 1px solid rgba(255, 255, 255, 0.20);
    color: rgba(255, 255, 255, 0.6);
    border-radius: 8px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
  }
  
  .sub-payment-tab:hover {
    border-color: rgba(255, 255, 255, 0.30);
    color: rgba(255, 255, 255, 0.8);
  }
  
  .sub-payment-tab--active {
    background: #007BFF;
    border-color: #007BFF;
    color: white;
  }
  
  /* ── Form ──────────────────────────────────────────────────────────────── */
  .sub-form {
    display: flex;
    flex-direction: column;
    gap: 0;
  }
  
  .sub-form-grid-2 {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0 20px;
    margin-bottom: 16px;
  }
  
  .sub-form-group {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }
  
  .sub-form-label {
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: rgba(255, 255, 255, 0.55);
  }
  
  .sub-form-hint {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.40);
    margin-top: 4px;
  }
  
  .sub-input {
    background: rgba(255, 255, 255, 0.06);
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 8px;
    color: #fff;
    padding: 10px 12px;
    font-size: 13.5px;
    outline: none;
    transition: border-color 0.2s ease, background 0.2s ease;
  }
  
  .sub-input:focus {
    border-color: #4caf50;
    background: rgba(76, 175, 80, 0.05);
  }
  
  /* ── Submit button ─────────────────────────────────────────────────────── */
  .sub-submit-btn {
    align-self: flex-start;
    margin-top: 8px !important;
  }
  
  /* ── Security badge ────────────────────────────────────────────────────── */
  .sub-security-badge {
    display: flex;
    align-items: center;
    gap: 8px;
    color: rgba(255, 255, 255, 0.5);
    font-size: 12px;
    margin-top: 16px;
  }
  
  /* ── Features grid ─────────────────────────────────────────────────────── */
  .sub-features-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    gap: 14px;
  }
  
  .sub-feature-card {
    display: flex;
    align-items: center;
    gap: 12px;
    background: rgba(0, 123, 255, 0.08);
    border: 1px solid rgba(0, 123, 255, 0.25);
    border-radius: 10px;
    padding: 14px;
    transition: border-color 0.2s ease, background 0.2s ease;
  }
  
  .sub-feature-card:hover {
    border-color: rgba(0, 123, 255, 0.40);
    background: rgba(0, 123, 255, 0.12);
  }
  
  .sub-feature-card-icon {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-weight: 700;
    color: white;
    flex-shrink: 0;
  }
  
  .sub-feature-card-content {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    gap: 3px;
  }
  
  .sub-feature-card-name {
    font-size: 13px;
    font-weight: 600;
    color: white;
  }
  
  .sub-feature-card-price {
    font-size: 11.5px;
    color: rgba(255, 255, 255, 0.50);
  }
  
  /* ── Responsive ────────────────────────────────────────────────────────── */
  @media (max-width: 768px) {
    .sub-form-grid-2 {
      grid-template-columns: 1fr;
      gap: 0;
    }
  
    .sub-payment-tabs {
      flex-direction: column;
    }
  
    .sub-features-grid {
      grid-template-columns: 1fr;
    }
  
    .sub-price {
      font-size: 36px;
    }
  }
  
  `, "",{"version":3,"sources":["webpack://./src/components/Pages/common/Settings/SettingsGridLayout.css"],"names":[],"mappings":"AAAA;;;mEAGmE;;AAEnE,6EAA6E;AAC7E;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,kCAAkC;EAClC,YAAY;EACZ,iBAAiB,YAAY,0CAA0C;EACvE,sBAAsB;AACxB;;AAEA,6EAA6E;AAC7E;EACE,WAAW;EACX,kCAAkC;EAClC,kDAAkD;EAClD,gBAAgB;EAChB,SAAS,oBAAoB,2CAA2C;EACxE,YAAY;EACZ,sBAAsB;AACxB;;AAEA,6EAA6E;AAC7E;EACE,UAAU;EACV,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB,QAAQ,4CAA4C;EACzE,sBAAsB;AACxB;;AAEA;EACE,aAAa,gBAAgB,4CAA4C;AAC3E;;AAEA,6EAA6E;AAC7E;EACE,cAAc;EACd,uBAAuB;EACvB,YAAY;EACZ,oCAAoC;EACpC,gCAAgC;EAChC,qEAAqE;EACrE,iBAAiB;EACjB,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;EACf,4DAA4D;EAC5D,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;AACvC;;AAEA,eAAe;AACf;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA,gCAAgC;AAChC;EACE,8BAA8B;AAChC;;AAEA;;EAEE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA,iCAAiC;AACjC;EACE,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,6EAA6E;AAC7E;EACE,UAAU;EACV,2BAA2B,GAAG,4CAA4C;EAC1E,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA,6EAA6E;AAC7E;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA,6EAA6E;AAC7E;EACE,kCAAkC;EAClC,2CAA2C;EAC3C,mBAAmB;EACnB,4BAA4B;EAC5B,WAAW;EACX,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,KAAK;AAClD;;AAEA;EACE,8CAA8C;EAC9C,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,+CAA+C;EAC/C,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA,6EAA6E;AAC7E;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,0DAA0D;EAC1D,sBAAsB;EACtB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,mCAAmC;EACnC,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,6EAA6E;AAC7E;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,uDAAuD;AACzD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,mCAAmC;EACnC,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mCAAmC;AACrC;;AAEA,6EAA6E;AAC7E;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,+CAA+C;EAC/C,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,kCAAkC;EAClC,mBAAmB;EACnB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,6EAA6E;AAC7E;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,kCAAkC;EAClC,wCAAwC;EACxC,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,6EAA6E;AAC7E;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;AACpC;;AAEA,mBAAmB,eAAe,EAAE;AACpC,mBAAmB,iBAAiB,EAAE,gBAAgB,EAAE,WAAW,EAAE;AACrE,mBAAmB,eAAe,EAAE,6BAA6B,EAAE,yBAAyB,EAAE,sBAAsB,EAAE;;AAEtH,6EAA6E;AAC7E;EACE,mCAAmC;EACnC,yCAAyC;EACzC,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,gCAAgC;EAChC,8CAA8C;AAChD;;AAEA,6EAA6E;AAC7E;EACE,yBAAyB,UAAU,EAAE;EACrC,0BAA0B,UAAU,EAAE;AACxC;;AAEA;EACE,yBAAyB,UAAU,EAAE,2BAA2B,EAAE;EAClE,0BAA0B,WAAW,EAAE,eAAe,EAAE;EACxD,0BAA0B,4BAA4B,EAAE;EACxD,0BAA0B,iBAAiB,EAAE,2BAA2B,EAAE;AAC5E;;AAEA;EACE,yBAAyB,WAAW,EAAE,2BAA2B,EAAE;EACnE,0BAA0B,4BAA4B,EAAE,mBAAmB,EAAE;EAC7E,0BAA0B,qCAAqC,EAAE;AACnE;;AAEA;;iEAEiE;;GAE9D;IACC,aAAa;IACb,sBAAsB;IACtB,MAAM;EACR;;EAEA,6EAA6E;EAC7E;IACE,mBAAmB;IACnB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,qCAAqC;IACrC,mCAAmC;EACrC;;EAEA;IACE,sCAAsC;IACtC,oCAAoC;EACtC;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,oBAAoB;IACpB,kDAAkD;EACpD;;EAEA,6EAA6E;EAC7E;IACE,cAAc;IACd,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,qBAAqB;IACrB,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA,6EAA6E;EAC7E;IACE,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,6DAA6D;EAC/D;;EAEA;IACE,gCAAgC;IAChC,wBAAwB;EAC1B;;EAEA,6EAA6E;EAC7E;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,+BAA+B;EACjC;;EAEA,6EAA6E;EAC7E;IACE,qBAAqB;IACrB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA,6EAA6E;EAC7E;IACE,+BAA+B;IAC/B,kBAAkB;IAClB,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,cAAc;IACd,kDAAkD;IAClD,+BAA+B;IAC/B,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA,6EAA6E;EAC7E;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,+BAA+B;EACjC;;EAEA,6EAA6E;EAC7E;IACE,aAAa;IACb,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,SAAO;IACP,kBAAkB;IAClB,uBAAuB;IACvB,2CAA2C;IAC3C,+BAA+B;IAC/B,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;EAC3B;;EAEA;IACE,uCAAuC;IACvC,+BAA+B;EACjC;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;IACrB,YAAY;EACd;;EAEA,6EAA6E;EAC7E;IACE,aAAa;IACb,sBAAsB;IACtB,MAAM;EACR;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,gCAAgC;EAClC;;EAEA;IACE,eAAe;IACf,gCAAgC;IAChC,eAAe;EACjB;;EAEA;IACE,qCAAqC;IACrC,2CAA2C;IAC3C,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,wDAAwD;EAC1D;;EAEA;IACE,qBAAqB;IACrB,mCAAmC;EACrC;;EAEA,6EAA6E;EAC7E;IACE,sBAAsB;IACtB,0BAA0B;EAC5B;;EAEA,6EAA6E;EAC7E;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,+BAA+B;IAC/B,eAAe;IACf,gBAAgB;EAClB;;EAEA,6EAA6E;EAC7E;IACE,aAAa;IACb,2DAA2D;IAC3D,SAAS;EACX;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mCAAmC;IACnC,yCAAyC;IACzC,mBAAmB;IACnB,aAAa;IACb,wDAAwD;EAC1D;;EAEA;IACE,qCAAqC;IACrC,mCAAmC;EACrC;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,gCAAgC;EAClC;;EAEA,6EAA6E;EAC7E;IACE;MACE,0BAA0B;MAC1B,MAAM;IACR;;IAEA;MACE,sBAAsB;IACxB;;IAEA;MACE,0BAA0B;IAC5B;;IAEA;MACE,eAAe;IACjB;EACF","sourcesContent":["/* ==================== SettingsGridLayout.css ====================\n   All classes prefixed st_ or st- to avoid global collisions.\n   No sidebar. Horizontal tab bar. Centred 80% container.\n   ============================================================== */\n\n/* ── Page wrapper ──────────────────────────────────────────────────────── */\n.st-page-wrapper {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  background: rgba(10, 10, 10, 0.97);\n  color: white;\n  padding-top: 70px;           /* ✅ clears fixed Navbar height          */\n  box-sizing: border-box;\n}\n\n/* ── Tab bar outer strip (full width, dark bg) ─────────────────────────── */\n.st-tab-bar-wrapper {\n  width: 100%;\n  background: rgba(18, 18, 18, 0.98);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  position: sticky;\n  top: 56px;                   /* ✅ sits just below the fixed Navbar     */\n  z-index: 100;\n  box-sizing: border-box;\n}\n\n/* ── Tab bar inner (centred, 80% wide, flex row) ───────────────────────── */\n.st-tab-bar {\n  width: 80%;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 4px;\n  padding: 0 0 0 0;\n  overflow-x: auto;\n  scrollbar-width: none;       /* hide scrollbar on Firefox               */\n  box-sizing: border-box;\n}\n\n.st-tab-bar::-webkit-scrollbar {\n  display: none;               /* hide scrollbar on Chrome/Safari         */\n}\n\n/* ── Individual tab button ─────────────────────────────────────────────── */\n.st-tab-btn {\n  flex-shrink: 0;\n  background: transparent;\n  border: none;\n  border-bottom: 3px solid transparent;\n  color: rgba(255, 255, 255, 0.50);\n  font-family: 'Trebuchet MS', 'Lucida Sans Unicode', Arial, sans-serif;\n  font-size: 13.5px;\n  font-weight: 500;\n  padding: 14px 16px 11px 16px;\n  cursor: pointer;\n  transition: color 0.18s ease, border-bottom-color 0.18s ease;\n  white-space: nowrap;\n  letter-spacing: 0.01em;\n}\n\n.st-tab-btn:hover {\n  color: rgba(255, 255, 255, 0.85);\n  background: rgba(255, 255, 255, 0.04);\n}\n\n/* Active tab */\n.st-tab-btn--active {\n  color: #ffffff !important;\n  border-bottom-color: white;\n  font-weight: 700;\n}\n\n/* Danger tab (Delete Account) */\n.st-tab-btn--danger {\n  color: rgba(244, 67, 54, 0.65);\n}\n\n.st-tab-btn--danger:hover,\n.st-tab-btn--danger.st-tab-btn--active {\n  color: #f44336 !important;\n  border-bottom-color: #f44336;\n}\n\n/* Logout — pushed to far right */\n.st-tab-btn--logout {\n  margin-left: auto;\n  color: rgba(255, 152, 0, 0.70);\n}\n\n.st-tab-btn--logout:hover {\n  color: #ff9800 !important;\n}\n\n/* ── Settings container (centred, 80%) ─────────────────────────────────── */\n.st-settings-container {\n  width: 80%;\n  margin: 40px auto 80px auto;  /* ✅ centred horizontally, breathing room  */\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n}\n\n/* ── Settings content area ─────────────────────────────────────────────── */\n.st-settings-content {\n  width: 100%;\n  box-sizing: border-box;\n}\n\n/* ── Panel base ────────────────────────────────────────────────────────── */\n.st-panel {\n  background: rgba(24, 24, 28, 0.85);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 16px;\n  padding: 36px 40px 44px 40px;\n  width: 100%;\n  box-sizing: border-box;\n  animation: st-panelFadeIn 0.22s ease;\n}\n\n@keyframes st-panelFadeIn {\n  from { opacity: 0; transform: translateY(10px); }\n  to   { opacity: 1; transform: translateY(0);    }\n}\n\n.st-panel-title {\n  font-family: 'Trebuchet MS', Arial, sans-serif;\n  font-size: 1.6rem;\n  font-weight: 700;\n  color: #ffffff;\n  margin: 0 0 6px 0;\n  padding: 0;\n}\n\n.st-panel-subtitle {\n  font-size: 0.9rem;\n  color: rgba(255, 255, 255, 0.45);\n  margin: 0 0 32px 0;\n  padding: 0;\n  line-height: 1.6;\n  border-bottom: 1px solid rgba(255,255,255,0.07);\n  padding-bottom: 20px;\n}\n\n.st-panel-body {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n/* ── Form rows ─────────────────────────────────────────────────────────── */\n.st-form-row {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin-bottom: 20px;\n}\n\n.st-form-label {\n  font-size: 13px;\n  font-weight: 600;\n  color: rgba(255, 255, 255, 0.55);\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n}\n\n.st-form-input {\n  background: rgba(255, 255, 255, 0.06);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 8px;\n  color: #ffffff;\n  font-size: 14px;\n  padding: 11px 14px;\n  outline: none;\n  transition: border-color 0.18s ease, background 0.18s ease;\n  box-sizing: border-box;\n  width: 100%;\n  max-width: 520px;\n}\n\n.st-form-input:focus {\n  border-color: #4caf50;\n  background: rgba(76, 175, 80, 0.06);\n}\n\n.st-form-input[readonly] {\n  opacity: 0.45;\n  cursor: default;\n}\n\n.st-form-textarea {\n  background: rgba(255, 255, 255, 0.06);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 8px;\n  color: #ffffff;\n  font-size: 14px;\n  padding: 11px 14px;\n  outline: none;\n  resize: vertical;\n  transition: border-color 0.18s ease;\n  box-sizing: border-box;\n  width: 100%;\n  max-width: 520px;\n  font-family: Arial, sans-serif;\n}\n\n.st-form-textarea:focus {\n  border-color: #4caf50;\n}\n\n.st-form-select {\n  background: rgba(255, 255, 255, 0.06);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 8px;\n  color: #ffffff;\n  font-size: 14px;\n  padding: 11px 14px;\n  outline: none;\n  cursor: pointer;\n  max-width: 520px;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.st-form-select option {\n  background: #1a1a1a;\n}\n\n/* ── Buttons ───────────────────────────────────────────────────────────── */\n.st-save-btn {\n  align-self: flex-start;\n  background: rgba(36,36,45,0.2);\n  color: #fff;\n  border: \"1px solid white\";\n  border-radius: 9px;\n  padding: 12px 32px;\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n  margin-top: 8px;\n  transition: transform 0.15s ease, box-shadow 0.15s ease;\n}\n\n.st-save-btn:hover {\n  transform: translateY(-1px);\n}\n\n.st-danger-btn {\n  align-self: flex-start;\n  background: rgba(244, 67, 54, 0.15);\n  color: #f44336;\n  border: 2px solid #f44336;\n  border-radius: 9px;\n  padding: 12px 32px;\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n\n.st-danger-btn:hover {\n  background: rgba(244, 67, 54, 0.28);\n}\n\n/* ── Toggle switch ─────────────────────────────────────────────────────── */\n.st-toggle-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 0;\n  border-bottom: 1px solid rgba(255,255,255,0.06);\n  max-width: 520px;\n}\n\n.st-toggle-label {\n  font-size: 14px;\n  color: rgba(255, 255, 255, 0.80);\n}\n\n.st-switch {\n  position: relative;\n  display: inline-block;\n  width: 44px;\n  height: 24px;\n  flex-shrink: 0;\n}\n\n.st-switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.st-slider {\n  position: absolute;\n  inset: 0;\n  background: rgba(255,255,255,0.15);\n  border-radius: 24px;\n  cursor: pointer;\n  transition: background 0.25s ease;\n}\n\n.st-slider::before {\n  content: \"\";\n  position: absolute;\n  width: 18px;\n  height: 18px;\n  left: 3px;\n  top: 3px;\n  background: #fff;\n  border-radius: 50%;\n  transition: transform 0.25s ease;\n}\n\n.st-switch input:checked + .st-slider {\n  background: #4caf50;\n}\n\n.st-switch input:checked + .st-slider::before {\n  transform: translateX(20px);\n}\n\n/* ── Info cards (Subscription) ─────────────────────────────────────────── */\n.st-info-card {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px;\n  background: rgba(255,255,255,0.04);\n  border: 1px solid rgba(255,255,255,0.08);\n  border-radius: 10px;\n  margin-bottom: 14px;\n  max-width: 520px;\n}\n\n.st-info-card-label {\n  font-size: 13px;\n  color: rgba(255,255,255,0.50);\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.st-info-card-value {\n  font-size: 15px;\n  font-weight: 700;\n  color: #ffffff;\n}\n\n/* ── Reward cards ──────────────────────────────────────────────────────── */\n.st-rewards-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));\n  gap: 16px;\n  max-width: 560px;\n}\n\n.st-reward-card {\n  background: rgba(255,255,255,0.05);\n  border: 1px solid rgba(255,255,255,0.09);\n  border-radius: 12px;\n  padding: 22px 16px;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  transition: background 0.2s ease;\n}\n\n.st-reward-card:hover {\n  background: rgba(255,255,255,0.08);\n}\n\n.st-reward-icon  { font-size: 2rem; }\n.st-reward-value { font-size: 1.4rem; font-weight: 700; color: #fff; }\n.st-reward-label { font-size: 12px; color: rgba(255,255,255,0.45); text-transform: uppercase; letter-spacing: 0.05em; }\n\n/* ── Danger box (Delete Account) ───────────────────────────────────────── */\n.st-danger-box {\n  background: rgba(244, 67, 54, 0.06);\n  border: 1px solid rgba(244, 67, 54, 0.22);\n  border-radius: 12px;\n  padding: 28px;\n  max-width: 560px;\n}\n\n.st-danger-input {\n  border-color: rgba(244, 67, 54, 0.4) !important;\n}\n\n.st-danger-input:focus {\n  border-color: #f44336 !important;\n  background: rgba(244, 67, 54, 0.06) !important;\n}\n\n/* ── Responsive ────────────────────────────────────────────────────────── */\n@media (max-width: 1024px) {\n  .st-settings-container { width: 90%; }\n  .st-tab-bar             { width: 90%; }\n}\n\n@media (max-width: 768px) {\n  .st-settings-container { width: 96%; margin: 24px auto 60px auto; }\n  .st-tab-bar             { width: 100%; padding: 0 12px; }\n  .st-panel               { padding: 24px 20px 32px 20px; }\n  .st-tab-btn             { font-size: 12.5px; padding: 12px 12px 9px 12px; }\n}\n\n@media (max-width: 480px) {\n  .st-settings-container { width: 100%; margin: 16px auto 48px auto; }\n  .st-panel               { padding: 18px 14px 28px 14px; border-radius: 10px; }\n  .st-rewards-grid        { grid-template-columns: repeat(2, 1fr); }\n}\n\n/* ==================== SUBSCRIPTION PANEL STYLES ====================\n   Prefix: sub- to avoid collisions with st- classes\n   ============================================================ */\n\n   .sub-root {\n    display: flex;\n    flex-direction: column;\n    gap: 0;\n  }\n  \n  /* ── Sections ──────────────────────────────────────────────────────────── */\n  .sub-section {\n    border-radius: 12px;\n    padding: 24px;\n    margin-bottom: 24px;\n  }\n  \n  .sub-section--payment {\n    border-color: rgba(76, 175, 80, 0.20);\n    background: rgba(76, 175, 80, 0.03);\n  }\n  \n  .sub-section--features {\n    border-color: rgba(33, 150, 243, 0.20);\n    background: rgba(33, 150, 243, 0.03);\n  }\n  \n  .sub-section-title {\n    font-size: 15px;\n    font-weight: 700;\n    color: #fff;\n    margin: 0 0 18px 0;\n    padding-bottom: 12px;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.07);\n  }\n  \n  /* ── Empty state ───────────────────────────────────────────────────────── */\n  .sub-empty-state {\n    color: #ffc107;\n    font-size: 14px;\n    padding: 20px 0;\n  }\n  \n  .sub-link {\n    color: #64b5f6;\n    text-decoration: none;\n    font-weight: 600;\n  }\n  \n  .sub-link:hover {\n    text-decoration: underline;\n  }\n  \n  /* ── Badges ────────────────────────────────────────────────────────────── */\n  .sub-badge {\n    display: inline-block;\n    padding: 8px 16px;\n    border-radius: 6px;\n    font-size: 13px;\n    font-weight: 700;\n    margin-bottom: 16px;\n    color: white;\n  }\n  \n  .sub-badge--all {\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  }\n  \n  .sub-badge--custom {\n    background: \"rgba(36,36,45,0.2)\";\n    border: \"1px solid gray\";\n  }\n  \n  /* ── Pricing display ───────────────────────────────────────────────────── */\n  .sub-pricing {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin-bottom: 18px;\n  }\n  \n  .sub-price {\n    font-size: 48px;\n    font-weight: 700;\n    color: #ffc107;\n  }\n  \n  .sub-period {\n    font-size: 16px;\n    color: rgba(255, 255, 255, 0.6);\n  }\n  \n  /* ── Savings badge ─────────────────────────────────────────────────────── */\n  .sub-savings {\n    display: inline-block;\n    background: #28a745;\n    color: white;\n    padding: 8px 12px;\n    border-radius: 6px;\n    font-size: 13px;\n    font-weight: 600;\n    margin-bottom: 18px;\n  }\n  \n  /* ── Features box ──────────────────────────────────────────────────────── */\n  .sub-features-box {\n    background: rgba(0, 0, 0, 0.25);\n    border-radius: 8px;\n    padding: 16px;\n    margin-top: 16px;\n  }\n  \n  .sub-features-title {\n    color: white;\n    font-size: 14px;\n    font-weight: 700;\n    margin: 0 0 12px 0;\n    padding: 0;\n  }\n  \n  .sub-features-list {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n  }\n  \n  .sub-feature-item {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 8px 0;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n    color: rgba(255, 255, 255, 0.8);\n    font-size: 13px;\n  }\n  \n  .sub-feature-item:last-child {\n    border-bottom: none;\n  }\n  \n  .sub-feature-check {\n    color: #ffc107;\n    margin-right: 8px;\n    font-weight: 700;\n  }\n  \n  .sub-feature-name {\n    flex: 1;\n  }\n  \n  .sub-feature-price {\n    color: #fff;\n    font-size: 12px;\n  }\n  \n  .sub-feature-price--free {\n    color: #20c997;\n    font-weight: 600;\n  }\n  \n  /* ── Checkbox row ──────────────────────────────────────────────────────── */\n  .sub-checkbox-row {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin-top: 20px;\n    padding: 12px 0;\n    cursor: pointer;\n  }\n  \n  .sub-checkbox {\n    width: 18px;\n    height: 18px;\n    cursor: pointer;\n    accent-color: #4caf50;\n  }\n  \n  .sub-checkbox-label {\n    font-size: 14px;\n    color: rgba(255, 255, 255, 0.8);\n  }\n  \n  /* ── Payment tabs ──────────────────────────────────────────────────────── */\n  .sub-payment-tabs {\n    display: flex;\n    gap: 12px;\n    margin-bottom: 24px;\n  }\n  \n  .sub-payment-tab {\n    flex: 1;\n    padding: 12px 16px;\n    background: transparent;\n    border: 1px solid rgba(255, 255, 255, 0.20);\n    color: rgba(255, 255, 255, 0.6);\n    border-radius: 8px;\n    font-size: 14px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.2s ease;\n  }\n  \n  .sub-payment-tab:hover {\n    border-color: rgba(255, 255, 255, 0.30);\n    color: rgba(255, 255, 255, 0.8);\n  }\n  \n  .sub-payment-tab--active {\n    background: #007BFF;\n    border-color: #007BFF;\n    color: white;\n  }\n  \n  /* ── Form ──────────────────────────────────────────────────────────────── */\n  .sub-form {\n    display: flex;\n    flex-direction: column;\n    gap: 0;\n  }\n  \n  .sub-form-grid-2 {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 0 20px;\n    margin-bottom: 16px;\n  }\n  \n  .sub-form-group {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n  }\n  \n  .sub-form-label {\n    font-size: 12px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    color: rgba(255, 255, 255, 0.55);\n  }\n  \n  .sub-form-hint {\n    font-size: 12px;\n    color: rgba(255, 255, 255, 0.40);\n    margin-top: 4px;\n  }\n  \n  .sub-input {\n    background: rgba(255, 255, 255, 0.06);\n    border: 1px solid rgba(255, 255, 255, 0.12);\n    border-radius: 8px;\n    color: #fff;\n    padding: 10px 12px;\n    font-size: 13.5px;\n    outline: none;\n    transition: border-color 0.2s ease, background 0.2s ease;\n  }\n  \n  .sub-input:focus {\n    border-color: #4caf50;\n    background: rgba(76, 175, 80, 0.05);\n  }\n  \n  /* ── Submit button ─────────────────────────────────────────────────────── */\n  .sub-submit-btn {\n    align-self: flex-start;\n    margin-top: 8px !important;\n  }\n  \n  /* ── Security badge ────────────────────────────────────────────────────── */\n  .sub-security-badge {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    color: rgba(255, 255, 255, 0.5);\n    font-size: 12px;\n    margin-top: 16px;\n  }\n  \n  /* ── Features grid ─────────────────────────────────────────────────────── */\n  .sub-features-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n    gap: 14px;\n  }\n  \n  .sub-feature-card {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    background: rgba(0, 123, 255, 0.08);\n    border: 1px solid rgba(0, 123, 255, 0.25);\n    border-radius: 10px;\n    padding: 14px;\n    transition: border-color 0.2s ease, background 0.2s ease;\n  }\n  \n  .sub-feature-card:hover {\n    border-color: rgba(0, 123, 255, 0.40);\n    background: rgba(0, 123, 255, 0.12);\n  }\n  \n  .sub-feature-card-icon {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 18px;\n    font-weight: 700;\n    color: white;\n    flex-shrink: 0;\n  }\n  \n  .sub-feature-card-content {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 3px;\n  }\n  \n  .sub-feature-card-name {\n    font-size: 13px;\n    font-weight: 600;\n    color: white;\n  }\n  \n  .sub-feature-card-price {\n    font-size: 11.5px;\n    color: rgba(255, 255, 255, 0.50);\n  }\n  \n  /* ── Responsive ────────────────────────────────────────────────────────── */\n  @media (max-width: 768px) {\n    .sub-form-grid-2 {\n      grid-template-columns: 1fr;\n      gap: 0;\n    }\n  \n    .sub-payment-tabs {\n      flex-direction: column;\n    }\n  \n    .sub-features-grid {\n      grid-template-columns: 1fr;\n    }\n  \n    .sub-price {\n      font-size: 36px;\n    }\n  }\n  \n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
